/*
==========================================================
IMPORTS
==========================================================
*/

import {

  useEffect,
  useState

} from "react";

/*
==========================================================
EMPTY USER
==========================================================
*/

const emptyUser = {

  displayName: "",

  email: "",

  companyId: "",

  role: "",

  status: "active",

  photoURL: ""

};

/*
==========================================================
CONTROLLER
==========================================================
*/

export default function useUserModalController({

  user,

  open,

  mode

}) {

  /*
  ==========================================================
  FORM
  ==========================================================
  */

  const [

    data,

    setData

  ] = useState(emptyUser);

  /*
  ==========================================================
  EFFECTS
  ==========================================================
  */

  useEffect(() => {

    if (!open) {

      return;

    }

    if (user) {

      setData({

        ...emptyUser,

        ...user

      });

    }

    else {

      setData(

        emptyUser

      );

    }

  }, [

    user,

    open

  ]);

  /*
  ==========================================================
  SETTINGS
  ==========================================================
  */

  const readOnly =

    mode === "view";

  /*
  ==========================================================
  ACTIONS
  ==========================================================
  */

  const handleChange = (event) => {

    const {

      name,

      value

    } = event.target;

    setData(previous => ({

      ...previous,

      [name]: value

    }));

  };

  const handleSelectChange = (

    field,

    option

  ) => {

    setData(previous => ({

      ...previous,

      [field]:

        option?.value || ""

    }));

  };

  /*
  ==========================================================
  FORM
  ==========================================================
  */

  const form = {

    data,

    readOnly

  };

  /*
  ==========================================================
  ACTIONS
  ==========================================================
  */

  const actions = {

    handleChange,

    handleSelectChange

  };

  /*
  ==========================================================
  RETURN
  ==========================================================
  */

  return {

    form,

    actions

  };

}